import React from 'react'
import logger from '../../../utils/logger'

export const CircleStatusComponent = ({ isVisible, lastname='', name='', state, enabled }) => {



    return (
        <div className="column-name-style" data-tag="allowRowEvents">
            {isVisible && (
                <div className={`circle-status ${state === "Active" && !enabled
                            ? "span-disabled" : `span-${state?.toLowerCase()}`}`}>

                </div>
            )}
            <span data-tag="allowRowEvents">{lastname} {name}</span>


        </div>
    )
}
